import { DependencyList, useEffect, useState } from "react"
import { WasmX } from "wasmx"
import { FetchStatus } from "./ApiHook"
import { useWasmX } from "./WasmXHook"

export function useWasmQuery<T>(fetcher: (wasmx: WasmX) => Promise<T | undefined>, deps?: DependencyList) {
    const [status, setStatus] = useState(FetchStatus.Init)
    const [data, setData] = useState<T>()
    const wasmx = useWasmX()

    const fetchData = async () => {
        try {
            setStatus(FetchStatus.Loading)
            const data = await fetcher(wasmx!)
            setData(data)
            setStatus(FetchStatus.Success)
        } catch (e) {
            setStatus(FetchStatus.Failed)
        }
    }

    useEffect(() => {
        if (wasmx) fetchData()
    }, [wasmx, ...(deps ?? [])])

    return {
        refresh: fetchData,
        data,
        status
    }
}